import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { Row } from 'modules/employees/pages/ImportProcessPage/components/ImportProcessWizard/EditionStep/editableContentReducer'

type Props = {
  rows: (Row | undefined)[] | undefined
  rowsWithError: number[]
  rowsWithWarning: number[]
  onClose: () => void
  onSubmit: () => void
  onReview: () => void
}

const CheckoutModal = ({
  rows,
  rowsWithError,
  rowsWithWarning,
  onClose,
  onSubmit,
  onReview,
}: Props) => {
  const totalEmployees = rows?.length || 0
  const selectedEmployees = rows?.filter((row) => row && row.selected) || []
  const warningEmployeesQtty = selectedEmployees.filter(
    (row) =>
      row &&
      row.index !== undefined &&
      rowsWithWarning.includes(row.index) &&
      !rowsWithError.includes(row.index)
  ).length
  const invalidEmployeesQtty = selectedEmployees.filter(
    (row) => row && row.index !== undefined && rowsWithError.includes(row.index)
  ).length
  const validEmployees = selectedEmployees.length - warningEmployeesQtty - invalidEmployeesQtty

  const handleOnSubmit = () => {
    track(trackingEvents.importEmployees.editionStep.confirm, {
      validEmployees,
      warningEmployeesQtty,
      invalidEmployeesQtty,
      totalEmployees,
    })
    onSubmit()
  }

  const handleReviewIssues = () => {
    onClose()
    onReview()
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('importer_process.edition_step.checkout_modal.title')}
      style={{ width: '456px' }}
      onSubmit={handleOnSubmit}
      onClose={onClose}
      footer={
        <>
          {(invalidEmployeesQtty || warningEmployeesQtty) && (
            <Button type="secondary" onClick={handleReviewIssues}>
              {i18n.tp('importer_process.edition_step.checkout_modal.secondary_action', {
                count: invalidEmployeesQtty + warningEmployeesQtty,
              })}
            </Button>
          )}
          {!validEmployees && !warningEmployeesQtty && (
            <Button type="primary" onClick={onClose}>
              {i18n.t('importer_process.edition_step.checkout_modal.got_it')}
            </Button>
          )}
          {(validEmployees || warningEmployeesQtty) && (
            <Button type="primary" submit>
              {i18n.t('importer_process.edition_step.next')}
            </Button>
          )}
        </>
      }
    >
      <Box flexDirection="column" width="full" gap="s24">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text.Normal size="300" color="grey1000" weight="medium">
              {i18n.t('importer_process.edition_step.checkout_modal.info_dots.uploaded')}
            </Text.Normal>
          </Box>
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {totalEmployees}
          </Text.Normal>
        </Box>
        <Box
          flexDirection="row"
          justifyContent="spaceBetween"
          paddingBottom="s24"
          border={{ bottom: { width: 's1', style: 'solid', color: 'grey400' } }}
        >
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text.Normal size="300" color="grey1000" weight="medium">
              {i18n.t('importer_process.edition_step.checkout_modal.info_dots.selected')}
            </Text.Normal>
          </Box>
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {selectedEmployees.length}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Icon.Medium icon="thumbs-up" color="lime1000" />
            <Text.Normal size="300" color="grey1000" weight="medium">
              {i18n.t('importer_process.edition_step.checkout_modal.info_dots.issue_free')}
            </Text.Normal>
          </Box>
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {validEmployees}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Icon.Medium icon="alert-sign" color="tangerine1000" />
            <Text.Normal size="300" color="grey1000" weight="medium">
              {i18n.t('importer_process.edition_step.checkout_modal.info_dots.with_issues')}
            </Text.Normal>
          </Box>
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {warningEmployeesQtty}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Icon.Medium icon="cross" color="radicalRed1000" />
            <Text.Normal size="300" color="grey1000" weight="medium">
              {i18n.t('importer_process.edition_step.checkout_modal.info_dots.cannot_create')}
            </Text.Normal>
          </Box>
          <Text.Normal size="300" weight="semibold" color="grey1000">
            {invalidEmployeesQtty}
          </Text.Normal>
        </Box>
      </Box>
    </Modal>
  )
}

export default CheckoutModal
